<h2 mat-dialog-title style="color: #A20000; text-align: center;">WARNING</h2>
<mat-dialog-content>
    <div style="padding-top:10px;padding-bottom:10px;" *ngIf="showDropdownWarning">
        <strong>This form contains dropdown controls.</strong> 
        Make sure the width you have selected for each of these is sufficient to display the entire length of the longest choice. 
        If not, this data will not be fully visible when viewing/approving the submitted form.
    </div>
    <div style="padding-top:10px;padding-bottom:10px;" *ngIf="showTextboxWarning">
        <strong>This form contains textbox controls.</strong>
        Make sure the width selected for each of these is sufficient for the length of the longest expected response.  
        If not, this data will not be fully visible when viewing/approving the submitted form.
    </div>
    <div style="padding-top:10px;padding-bottom:10px;">
        If you are comfortable with the properties currently assigned to these controls, select Continue.
    </div>
    <div style="padding-top:10px;padding-bottom:10px;">Otherwise, select Cancel and review the properties.</div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex-footer-left'>

    </div>
    <div class='flex-footer-right'>
        <tyl-button image="next arrow.png" label="Continue" (clickEvent)="continueClick()"></tyl-button>
        <tyl-button image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>